import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class SimilarityCodeFilter implements IExerciseSelectionFilter {
    public description: string = 'Returns only exercises that are not similar to those assigned to other zones already';
    public name: string = 'SimilarityCodeFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[]): Exercise[] {
        const similarityCodesSoFar = selectedZoneExercisesSoFar.map((e) => e.similarityCode);
        const flattenedSimCodesSoFar = [].concat.apply([], similarityCodesSoFar);
        const uniqueSimilarityCodesSoFar = Array.from(new Set(flattenedSimCodesSoFar));

        return inputExercises.filter((e) => {
            if (e.similarityCode == null || e.similarityCode.length === 0) {
                return true;
            }

            const matched = e.similarityCode.filter((simCode) =>
                uniqueSimilarityCodesSoFar.indexOf(simCode) !== -1,
            );

            return matched.length === 0;
        });
    }
}
